export const REGEX = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  PASSWORD: /^[a-zA-Z0-9]{6,14}$/,
  NOT_WHITESPACE: /^(?!.*[\s])/,
  INT_NUMBER: /^[0-9]+$/,
  REGEX_CODE: /^\d{4}$/
}
